import React from 'react';
import { formatCedi } from '../utils/formatters';

export default function OrderFAB({ itemCount, total, onOpen }) {
  return (
    <button type="button" className="pos-order-fab" onClick={onOpen} aria-label="View order">
      <span className="pos-order-fab-label">
        View Order ({itemCount} {itemCount === 1 ? 'item' : 'items'})
      </span>
      <span className="pos-order-fab-total">
        {formatCedi(total)}
      </span>
    </button>
  );
}
